import React, { useState, useEffect } from 'react';
import pinataClient, { PinataClient } from '@pinata/sdk';
import Context from './Context';

const Provider: React.FC = ({ children }) => {
  const [client, setClient] = useState<PinataClient>();

  useEffect(() => {
    const load = () => {
      setClient(pinataClient(
        process.env.REACT_APP_PINATA_API_KEY as string,
        process.env.REACT_APP_PINATA_API_SECRET as string
      ));
    };
    load();
  }, []);

  if (!client) {
    return null;
  }

  return (
    <Context.Provider
      value={{
        client,
        apiKey: process.env.REACT_APP_PINATA_API_KEY as string,
        apiSecret: process.env.REACT_APP_PINATA_API_SECRET as string,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Provider;
